export class HistoricalChangeToInventoryConfirm {

    Id: string;

    WorkOrderId: string;

    HistoricalEffectiveDate: Date;
}
